/* Purpose: Footer with basic contact details and a sign out button if the user is signed in
 * Props: signOutRedirect (func) --optional
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React from "react";
import SubmitButton from "../Components/Button";
import { Col, Row } from "react-bootstrap";
import '../custom.scss'

const Footer = (props) => {
    const logo = require("../Images/iskaLogo.png")
    return(
        <div className='text-center align-items-center footer'>
            {/* If the footer needs a sign out button */}
            {props.signOutRedirect && (
                <div className='signout-btn align-items-center w-100'>
                    <SubmitButton onClick={props.signOutRedirect} text = 'Sign out' width = "75" />
                </div>
            )}
            <Row className="footer-text" xs = {1} sm = {1} md = {2} lg = {2} xl = {2} >
            <Col md = {7} lg = {6} xl = {6} className = "my-auto text-white">
                CONTACT US:
                info@iskamortgage.com  | 
                (732) 228-4661
            </Col>
            
            <Col md = {5} lg = {6} xl = {6} className="my-auto text-white">©2025 ISKA MORTGAGE</Col>
            </Row>
        </div>
    )
}

export default Footer;